export function updateTime(inputDate) {
  const date = new Date(inputDate)

  let hours = date.getUTCHours()
  let minutes = date.getUTCMinutes()

  const ampm = hours >= 12 ? "pm" : "am"

  hours = hours % 12
  hours = hours ? hours : 12
  minutes = minutes + 1

  //const dateString = inputDate;

  //  console.log(`Hours: ${hours}, Minutes: ${minutes}, String ${inputDate}`);

  return `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")} ${ampm}`
}

export const ExpandableText = ({
  text,
  descriptionLength,
  NotificationType,
}) => {
  const fullText = text.anntext
  const [isExpanded, setIsExpanded] = useState(false)
  const toggleText = () => setIsExpanded(!isExpanded)

  // console.log(text.type_label)
  const shouldShowReadMore = fullText.length > descriptionLength

  const notificationTypes = {
    1: "Homework",
    2: "Announcement",
    3: "Student Specific",
    // 12: "Message"
  }
}
